import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  form: {
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 28,
    width: 400,
    maxWidth: '100%'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    padding: '20px 0 0',
    width: '100%'
  },
  groups: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/addform/AddForm.styles.js